import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Login from '@/views/login/index'
import AccountCenter from '@/views/accountcenter/index'
import DownManage from '@/views/downmanage/index'
import AnnouncementCenter from '@/views/announcementcenter/index'
import AnnouncementCenterDetail from '@/views/announcementcenter/detail'
import Help from '@/views/help/index'

Vue.use(Router)
export const constantRoutes = [
  {
    path: '/',
    name: 'Home',
    meta: { title: '首页' },
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    meta: { title: '登录' },
    component: Login
  },
  {
    path: '/accountcenter',
    name: 'AccountCenter',
    meta: { title: '账户中心' },
    component: AccountCenter
  },
  {
    path: '/downmanage',
    name: 'DownManage',
    meta: { title: '下载' },
    component: DownManage
  },
  {
    path: '/announcementcenter',
    name: 'AnnouncementCenter',
    meta: { title: '公告' },
    component: AnnouncementCenter
  },
  {
    path: '/announcementcenterdetail',
    name: 'AnnouncementCenterDetail',
    meta: { title: '公告详情' },
    component: AnnouncementCenterDetail
  },
  {
    path: '/help',
    name: 'Help',
    meta: { title: '帮助' },
    component: Help
  }
]
const createRouter = () => new Router({
  // mode: 'history',
  // base: '/static/admin/',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export default router
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/router/index.js